<template>
  <div class="relative w-full h-auto py-[3.75vw]">
    <el-image
      class="absolute top-0 left-0 w-full h-full"
      :src="backgroundImage"
      lazy
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2.71vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#FFFFFF] font-harmony font-bold leading-[3.25vw] text-center"
        >
          专家顾问团队
        </div>
      </div>
    </div>

    <!-- 内容框 -->
    <div
      class="relative left-1/2 -translate-x-1/2 flex flex-col items-center gap-[2.24vw] w-[61.46vw] h-auto"
    >
      <!-- 院士简介区块 -->
      <div class="flex w-full h-auto bg-white rounded-lg">
        <!-- 头像 -->
        <div class="w-[11.25vw] h-[14.48vw]">
          <el-image
            class="w-full h-full object-cover rounded-l-lg"
            :src="`https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/aboutus/module3/image1.png`"
            lazy
            alt="图片"
          />
        </div>
        <!-- 简介 -->
        <div
          class="flex flex-col justify-center w-[19.48vw] px-[2.08vw] gap-[1.25vw] bg-white"
        >
          <p
            class="text-[1.25vw] text-[#1A2233] font-harmony font-bold text-start"
          >
            院士顾问
          </p>
          <div class="flex flex-col gap-[0.42vw]">
            <p
              class="text-[1.04vw] text-[#676B73] font-harmony font-medium text-start"
            >
              吾守尔·斯拉木院士
            </p>
            <p
              class="text-[1.04vw] text-[#9CA3AF] font-harmony font-regular text-start"
            >
              中国工程院院士
            </p>
            <p
              class="text-[1.04vw] text-[#9CA3AF] font-harmony font-regular text-start"
            >
              多语种信息处理专家
            </p>
          </div>
        </div>

        <!-- 详情 -->
        <div
          class="flex flex-col justify-center flex-1 px-[2.29vw] gap-[0.83vw] bg-[#F0F3FF] rounded-r-lg"
        >
          <p
            class="text-[1.25vw] text-[#1A2233] font-harmony font-medium text-start"
          >
            院士工作站简介
          </p>
          <p
            class="text-[0.83vw] text-[#9CA3AF] font-harmony font-regular text-justify"
            style="text-justify: inter-ideograph"
          >
            陕西师范大学出版总社院士工作站，是以中国工程院吾守尔·斯拉木院士及其团队为核心，依托陕西师范大学出版总社及有关教学科研单位，联合进行科学技术研究与应用的高层次科技创新平台。2023年4月12日获批陕西省第二批省级院士工作站授牌。
          </p>
        </div>
      </div>

      <!-- 专家顾问区块 -->
      <div class="grid grid-cols-6 w-full h-auto rounded-lg gap-[0.83vw]">
        <div v-for="(expert, index) in experts" :key="index">
          <div class="flex flex-col bg-white rounded-lg">
            <el-image
              :src="
                `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/aboutus/module3/image${index + 2}.png`
              "
              class="w-[9.55vw] h-[13.02vw] rounded-t-lg object-cover"
              lazy
              alt="图片"
            />
            <div class="flex flex-col justify-center px-[0.83vw] py-[1.25vw]">
              <div
                class="mb-[0.83vw] text-[1.04vw] text-[#1A2233] font-harmony font-bold"
              >
                {{ expert.info }}
              </div>
              <div
                class="text-[0.83vw] text-[#676B73] font-harmony font-medium"
              >
                {{ expert.name }}
              </div>
              <div
                class="text-[0.68vw] text-[#9CA3AF] font-harmony font-regular"
              >
                {{ expert.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "abouotus-module3",
  data() {
    return {
      backgroundImage: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/aboutus/module3/sample1.png`,
      experts: [
        {
          info: "专家顾问",
          name: "杨森教授",
          title: "西安交通大学",
        },
        {
          info: "专家顾问",
          name: "王保平教授",
          title: "西北工业大学",
        },
        {
          info: "专家顾问",
          name: "孙涛",
          title: "机械自动化专家",
        },
        {
          info: "教材开发专家",
          name: "王林波老师",
          title: "陕师大附小国家特级教师",
        },
        {
          info: "教材开发专家",
          name: "王强教授",
          title: "人工智能专家",
        },
        {
          info: "教材开发专家",
          name: "吴冰教授",
          title: "陕西师范大学",
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>